import { render, staticRenderFns } from "./more.vue?vue&type=template&id=28ffac1d&scoped=true&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&id=28ffac1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffac1d",
  null
  
)

export default component.exports